<script>
import VueTagsInput from '@johmun/vue-tags-input'
import store from '@state/store'
import { Cropper } from 'vue-advanced-cropper'
import VimeoUpload from '@utils/vimeo-upload'
import { authComputed } from '@state/helpers'

export default {
  name: 'PostEdit',
  components: { VueTagsInput, Cropper },
  props: { onePost: { type: Object, required: true } },
  data() {
    return {
      content: this.onePost.text,
      hours: this.onePost.hours,
      kyndCode: this.onePost.kynd_code,
      contentPlaceholder: 'What did you do?',
      debounce: null,
      showWhatTags: false,
      whoDidIt: '',
      whoDidItTag: '',
      whoDidItTags: this.getWhoDidItTags(),
      autocompleteWhoDidItItems: [],
      maxWhoDidItTags: 1,
      organization: '',
      organizationTag: '',
      organizationTags: this.getOrganizationTags(),
      autocompleteOrganizationItems: [],
      maxOrganizationTags: 1,
      cause: '',
      causeTag: '',
      causeTags: this.getCauseTags(),
      autocompleteCauseItems: [],
      friends: '',
      friendsTag: '',
      friendsTags: this.getFriendsTags(),
      autocompleteFriendsItems: [],
      other: '',
      otherTag: '',
      otherTags: this.getOtherTags(),
      autocompleteOtherItems: [],
      nextOne: '',
      nextOneTag: '',
      nextOneTags: this.getNextOneTags(),
      autocompleteNextOneItems: [],
      maxNextOneTags: 1,
      image: null,
      justVideos: [],
      justImages: this.onePost.image_url,
      totalFiles: 0,
      oldLoaded: [],
      imagesDone: true,
      videosDone: true,
      toCropImages: [],
      cropIndex: 1,
      visibleImageCropper: false,
      croppedImages: this.onePost.image_url,
      shouldShowDone: false,
      videoUrl: [],
      progress: 0,
      startedToSendPost: false,
    }
  },
  computed: {
    ...authComputed,
    postType() {
      return this.onePost.type
    },
    kyndnessType() {
      return this.onePost.kyndness_type ? this.onePost.kyndness_type : false
    },
    charityOrganization() {
      return this.onePost.charity_organization != null
        ? this.onePost.charity_organization.name.toUpperCase()
        : ''
    },
    postTags() {
      const tags = []
      for (var i = this.onePost.tags.length - 1; i >= 0; i--) {
        tags.push('#' + this.onePost.tags[i].name)
      }
      return tags.join(', ')
    },
    postCauses() {
      const causes = []
      for (var i = this.onePost.causes.length - 1; i >= 0; i--) {
        causes.push(this.onePost.causes[i].name)
      }
      return causes.join(', ')
    },
    postFriends() {
      const friends = []
      for (var i = this.onePost.friends.length - 1; i >= 0; i--) {
        friends.push(this.onePost.friends[i].name)
      }
      return friends.join(', ')
    },
    shouldShowNextOne() {
      return this.postType === 'kyndness'
    },
    shouldShowOrganization() {
      return this.postType === 'volunteered' || this.postType === 'donation'
    },
    shouldShowCause() {
      return this.postType === 'volunteered' || this.postType === 'donation'
    },
    shouldShowFriends() {
      return (
        this.postType === 'volunteered' ||
        this.postType === 'kyndness' ||
        this.postType === 'gratitude' ||
        this.postType === 'note'
      )
    },
    shouldShowAmount() {
      return this.postType === 'donation'
    },
    shouldShowDidIt() {
      return (
        this.postType === 'kyndness' &&
        (this.kyndnessType === 'receive' || this.kyndnessType === 'witnessed')
      )
    },
    shouldShowHours() {
      return this.postType === 'volunteered'
    },
    progressReadable() {
      return this.justVideos.length > 0
        ? `Loading ${parseInt(this.progress * 100)}%`
        : 'Loading...'
    },
  },
  watch: {
    whoDidItTag: 'initWhoDidItItems',
    organizationTag: 'initOrganizationItems',
    causeTag: 'initCauseItems',
    friendsTag: 'initFriendsItems',
    otherTag: 'initOtherItems',
    nextOneTag: 'initNextOneItems',
  },
  methods: {
    postStatusUpdate() {
      this.startedToSendPost = true
      if (!this.videosDone && this.justVideos.length > 0) {
        for (var i = this.justVideos.length - 1; i >= 0; i--) {
          var vimeovideo = []

          this.createNewVimeo(vimeovideo, i, this.sendStatusUpdate)
        }
      } else {
        this.sendStatusUpdate()
      }
    },
    sendStatusUpdate() {
      if (this.videosDone) {
        const data = JSON.parse(JSON.stringify(this.onePost))
        if (this.shouldShowAmount) {
          data.amount = this.amount
        }
        if (this.shouldShowHours) {
          data.hours = this.hours
        }
        if (this.onePost.text !== this.content) {
          data.text = this.content
        }
        data.challenge = this.nextOneTags
        data.giver = this.whoDidItTags
        data.organization = this.organizationTags[0]
        data.causes = this.causeTags
        data.friends = this.friendsTags
        data.tags = this.otherTags
        data.images = this.croppedImages
        data.videoUrl = this.videoUrl

        this.$emit('save-status-update', data)
      }
    },
    createNewVimeo(vimeovideo, i, onSuccess) {
      const that = this
      vimeovideo[i] = new VimeoUpload({
        name: this.justVideos[i].$$hashKey,
        description: 'description',
        upgrade_to_1080: false,
        file: this.justVideos[i],
        token: '11aed05a5c2aa6a2e222a1bca880e368',
        onError: function(data) {},
        onProgress: function(data) {
          that.oldLoaded[i] = data.loaded
          that.progress =
            that.oldLoaded.reduce(function(a, b) {
              return a + b
            }) / that.totalFiles

          if (that.progress === 1) that.progress = 0.99
        },
        onComplete: function(videoId, index) {
          that.videoUrl.push(videoId)
          if (that.videoUrl.length === that.justVideos.length) {
            that.videosDone = true
            onSuccess()
          }
        },
      })
      vimeovideo[i].upload()
    },
    setShowWhatTags(tagsName) {
      this.showWhatTags = this.showWhatTags === tagsName ? '' : tagsName
    },
    getWhoDidItTags() {
      if (this.onePost.giver) {
        return [
          {
            text: this.onePost.giver.name,
            name: this.onePost.giver.name,
            id: this.onePost.giver.id,
          },
        ]
      }
      return []
    },
    updateWhoDidIt(newTags) {
      this.autocompleteWhoDidItItems = []
      this.whoDidItTags = newTags
    },
    initWhoDidItItems() {
      if (
        this.maxWhoDidItTags > 0 &&
        this.whoDidItTags.length >= this.maxWhoDidItTags
      )
        return

      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        store
          .dispatch('companies/fetchFriends', {
            startingWith: this.whoDidItTag,
          })
          .then((response) => {
            this.autocompleteWhoDidItItems = response.data.map((a) => {
              return { text: a.name, id: a.id }
            })
          })
          .catch(() => console.warn('Oh. Something went wrong'))
      }, 500)
    },
    getOrganizationTags() {
      if (this.onePost.charity_organization) {
        return [
          {
            text: this.onePost.charity_organization.name,
            name: this.onePost.charity_organization.name,
            id: this.onePost.charity_organization.id,
          },
        ]
      }
      return []
    },
    organizationPlaceholder() {
      if (this.organizationTags.length >= this.maxOrganizationTags) {
        return ''
      }
      return 'Search Organization'
    },
    updateOrganization(newTags) {
      if (newTags.length === 0) {
        this.organizationPlaceholder = 'Search Organization'
      } else if (newTags.length >= this.maxOrganizationTags) {
        this.organizationPlaceholder = ''
      }
      this.autocompleteOrganizationItems = []
      this.organizationTags = newTags
    },
    initOrganizationItems() {
      if (
        this.maxOrganizationTags > 0 &&
        this.organizationTags.length >= this.maxOrganizationTags
      )
        return

      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        store
          .dispatch('companies/fetchOrganizations', {
            startingWith: this.organizationTag,
          })
          .then((response) => {
            this.autocompleteOrganizationItems = response.data.map((a) => {
              return { text: a.name, id: a.id }
            })
          })
          .catch(() => console.warn('Oh. Something went wrong'))
      }, 500)
    },
    getCauseTags() {
      const causes = []
      for (var i = 0; i < this.onePost.causes.length; i++) {
        causes.push({
          text: this.onePost.causes[i].name,
          name: this.onePost.causes[i].name,
          id: this.onePost.causes[i].id,
        })
      }
      return causes
    },
    updateCause(newTags) {
      // this.autocompleteCauseItems = []
      this.causeTags = newTags
    },
    initCauseItems() {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        store
          .dispatch('companies/fetchCauses')
          .then((response) => {
            this.autocompleteCauseItems = response.data.map((a) => {
              return { text: a.name, id: a.id }
            })
          })
          .catch(() => console.warn('Oh. Something went wrong'))
      }, 500)
    },
    getFriendsTags() {
      const friends = []
      for (var i = 0; i < this.onePost.friends.length; i++) {
        friends.push({
          text: this.onePost.friends[i].name,
          name: this.onePost.friends[i].name,
          id: this.onePost.friends[i].id,
        })
      }
      return friends
    },
    updateFriends(newTags) {
      this.autocompleteFriendsItems = []
      this.friendsTags = newTags
    },
    initFriendsItems() {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        store
          .dispatch('companies/fetchFriends', {
            startingWith: this.friendsTag,
          })
          .then((response) => {
            this.autocompleteFriendsItems = response.data.map((a) => {
              return { text: a.name, id: a.id }
            })
          })
          .catch(() => console.warn('Oh. Something went wrong'))
      }, 500)
    },
    getOtherTags() {
      const tags = []
      for (var i = 0; i < this.onePost.tags.length; i++) {
        tags.push({
          text: this.onePost.tags[i].name,
          name: this.onePost.tags[i].name,
          id: this.onePost.tags[i].id,
        })
      }
      return tags
    },
    updateOther(newTags) {
      this.autocompleteOtherItems = []
      this.otherTags = newTags
    },
    initOtherItems() {
      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        store
          .dispatch('companies/fetchTags', {
            startingWith: this.otherTag,
          })
          .then((response) => {
            this.autocompleteOtherItems = response.data.map((a) => {
              return { text: a.name, id: a.id }
            })
          })
          .catch(() => console.warn('Oh. Something went wrong'))
      }, 500)
    },
    nextOnePlaceholder() {
      if (this.nextOneTags.length >= this.maxNextOneTags) {
        return ''
      }
      return 'Search Friends'
    },
    getNextOneTags() {
      const nexts = []
      for (var i = 0; i < this.onePost.challenged.length; i++) {
        nexts.push({
          text: this.onePost.challenged[i].name,
          name: this.onePost.challenged[i].name,
          id: this.onePost.challenged[i].id,
        })
      }
      return nexts
    },
    updateNextOne(newTags) {
      if (newTags.length === 0) {
        this.nextOnePlaceholder = 'Search Friends'
      } else if (newTags.length >= this.maxNextOneTags) {
        this.nextOnePlaceholder = ''
      }
      this.autocompleteNextOneItems = []
      this.nextOneTags = newTags
    },
    initNextOneItems() {
      if (
        this.maxNextOneTags > 0 &&
        this.nextOneTags.length >= this.maxNextOneTags
      )
        return

      clearTimeout(this.debounce)
      this.debounce = setTimeout(() => {
        store
          .dispatch('companies/fetchFriends', {
            startingWith: this.nextOneTag,
          })
          .then((response) => {
            this.autocompleteNextOneItems = response.data.map((a) => {
              return { text: a.name, id: a.id }
            })
          })
          .catch(() => console.warn('Oh. Something went wrong'))
      }, 500)
    },
    getCropIndex() {
      return this.cropIndex
    },
    uploadFiles(event) {
      var input = event.target
      this.justVideos = []
      this.justImages = []
      this.toCropImages = []
      this.cropIndex = 1
      if (input.files && input.files.length > 0) {
        for (let i = 0; i < input.files.length; i++) {
          if (input.files[i].type.includes('video')) {
            this.justVideos.push(input.files[i])
            this.totalFiles = this.totalFiles + input.files[i].size
            this.oldLoaded[this.justVideos.length - 1] = 0
          } else {
            this.justImages.push(input.files[i])
          }
        }

        if (this.justVideos.length > 0) {
          this.videosDone = false
        } else {
          this.videosDone = true
        }

        if (this.justImages.length > 0) {
          for (let i = 0; i < this.justImages.length; i++) {
            if (typeof this.justImages[i] === 'string') {
              this.toCropImages.push({
                original: this.justImages[i],
                cropped: null,
              })
            } else {
              const reader = new FileReader()
              reader.onload = (e) => {
                this.toCropImages.push({
                  original: e.target.result,
                  cropped: null,
                })
              }
              reader.readAsDataURL(this.justImages[i])
            }
          }
          input.type = 'text'
          input.type = 'file'
          if (this.justImages.length === 1) this.shouldShowDone = true
          this.visibleImageCropper = true
          this.imagesDone = false
        } else {
          this.imagesDone = true
        }
      }
    },
    crop() {
      const { coordinates, canvas } = this.$refs.cropper.getResult()
      this.coordinates = coordinates
      this.toCropImages[this.cropIndex - 1].cropped = canvas.toDataURL()
    },
    clickOnFileUpload() {
      this.$refs.file.click()
    },
    previousCrop() {
      this.crop()
      this.cropIndex = this.cropIndex > 0 ? this.cropIndex - 1 : 0
    },
    nextCrop() {
      this.crop()
      this.cropIndex =
        this.cropIndex < this.toCropImages.length ? this.cropIndex + 1 : 0
      if (this.cropIndex === this.toCropImages.length)
        this.shouldShowDone = true
    },
    removeImage() {
      const toDelete = this.cropIndex - 1
      if (this.cropIndex === this.toCropImages.length) this.previousCrop()
      else this.nextCrop()

      this.toCropImages.splice(toDelete, 1)
      this.justImages.splice(toDelete, 1)
    },
    onClose() {
      this.visibleImageCropper = false
    },
    finishCropping() {
      this.crop()
      this.croppedImages = []
      for (let i = 0; i < this.toCropImages.length; i++) {
        this.croppedImages.push(this.toCropImages[i].cropped)
      }
      this.visibleImageCropper = false
    },
    hide() {
      this.visible = false
    },
  },
}
</script>

<template>
  <BaseModalWindow
    modalcls="post-form w-new-post flex bg-white rounded-xl ml-15 px-5 pt-8 pb-3 shadow-box relative left-0"
    :visible="true"
    @close="$emit('close')"
  >
    <template v-slot:body>
      <div class="w-9.5 mr-4 flex-shrink-0">
        <img
          :src="onePost.user.image_url"
          class="mr-3.5 rounded-full h-9.5 w-9.5"
        />
      </div>
      <div class="flex-grow">
        <div class="text-basel mb-2 mr-4">
          <textarea
            v-model="content"
            :placeholder="contentPlaceholder"
            class="w-full outline-none appearance-none resize-y"
            rows="4"
          >
          </textarea>
        </div>
        <div
          v-if="shouldShowHours || shouldShowDidIt || shouldShowAmount"
          class="mb-6 flex"
        >
          <div v-if="shouldShowHours" class="mr-6 w-1/4">
            <label for="hours" class="block mb-3">Hours</label>
            <input
              v-model="hours"
              type="number"
              name="hours"
              class="input"
              min="0"
              step="0.25"
            />
          </div>
          <div v-if="shouldShowAmount" class="mr-6 w-1/4">
            <label for="amount" class="block mb-3">Amount</label>
            <input
              v-model="amount"
              type="number"
              name="amount"
              class="input"
              min="0"
              max="999999"
            />
          </div>
          <div v-if="shouldShowDidIt" class="mr-6 w-1/2">
            <label for="whoDidIt" class="block mb-3">Who did it?</label>
            <VueTagsInput
              v-model="whoDidItTag"
              :tags="whoDidItTags"
              :autocomplete-items="autocompleteWhoDidItItems"
              :add-only-from-autocomplete="true"
              placeholder=""
              :autocomplete-min-length="2"
              :max-tags="maxWhoDidItTags"
              @tags-changed="updateWhoDidIt"
            />
          </div>
        </div>
        <div class="mb-6">
          <button
            v-if="!startedToSendPost"
            class="button primary-button h-12 inline-block text-right mr-2"
            @click="postStatusUpdate"
            >Save</button
          >
          <button
            v-if="startedToSendPost"
            class="button primary-button h-12 inline-block text-right"
            >{{ progressReadable }}</button
          >
        </div>
        <div class="flex mr-4 mb-6">
          <div class="mr-12">
            <button @click="clickOnFileUpload">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="28"
                height="22"
                viewBox="0 0 28 22"
                class=""
              >
                <g
                  id="Group_222"
                  data-name="Group 222"
                  transform="translate(-1.972 -12.553)"
                >
                  <path
                    id="Path_67"
                    data-name="Path 67"
                    d="M35.688,45.9A5.913,5.913,0,1,1,41.6,39.987,5.919,5.919,0,0,1,35.688,45.9Zm0-10.212a4.3,4.3,0,1,0,4.3,4.3,4.305,4.305,0,0,0-4.3-4.3Z"
                    transform="translate(-19.675 -15.23)"
                    fill="#069bd7"
                  />
                  <path
                    id="Path_68"
                    data-name="Path 68"
                    d="M26.961,15.068H12.728V14.045a1.493,1.493,0,0,0-1.492-1.492H6.447a1.493,1.493,0,0,0-1.492,1.492v1.029A3.094,3.094,0,0,0,1.972,18.16V31.355a3.1,3.1,0,0,0,3.092,3.092h21.9a3.1,3.1,0,0,0,3.092-3.092V18.16A3.1,3.1,0,0,0,26.961,15.068ZM28.44,31.354a1.481,1.481,0,0,1-1.48,1.48H5.064a1.481,1.481,0,0,1-1.479-1.48V18.16A1.481,1.481,0,0,1,5.064,16.68h.452a1.016,1.016,0,0,0,1.052-1.051V14.165h4.547l-.006,1.06s0-.664,0,.4a1.014,1.014,0,0,0,1.049,1.051h14.8a1.481,1.481,0,0,1,1.479,1.48V31.354Z"
                    transform="translate(0)"
                    fill="#069bd7"
                  />
                </g></svg
            ></button>
            <span
              v-if="croppedImages.length > 0 || oldLoaded.length > 0"
              class="absolute bg-blue rounded-full w-4.5 h-4.5 inline-block leading-normal text-white text-center text-sm -ml-2 -mt-2"
              >{{ croppedImages.length + oldLoaded.length }}</span
            >
            <input
              ref="file"
              type="file"
              multiple
              accept="image/*,video/*"
              @change="uploadFiles($event)"
            />
            <BaseModalWindow
              v-if="justImages.length > 0"
              modalcls="w-user-edit bg-white rounded-xl mx-10 px-11 shadow-box relative left-0 flex justify-between overflow-hidden"
              :visible="visibleImageCropper"
              @close="onClose"
            >
              <template v-slot:body>
                <div class="w-full mx-auto mt-12 mb-5">
                  <div class="">
                    <Cropper
                      v-if="toCropImages.length > 0"
                      ref="cropper"
                      :stencil-props="{
                        aspectRatio: 3 / 2,
                      }"
                      classname="w-full"
                      :src="toCropImages[cropIndex - 1].original"
                    />
                  </div>
                  <div class="w-full flex justify-between mt-3">
                    <div class="text-right ">
                      <button
                        class="button primary-button bg-volunteer_red h-7.5 leading-relax text-sml rounded-small-button px-3"
                        @click="removeImage"
                        >Remove</button
                      >
                      <button
                        v-show="cropIndex > 1"
                        class="button primary-button bg-donation h-7.5 leading-relax text-sml rounded-small-button px-3 ml-3"
                        @click="previousCrop"
                        >Previous</button
                      >
                      <button
                        v-show="cropIndex < toCropImages.length"
                        class="button primary-button bg-donation h-7.5 leading-relax text-sml rounded-small-button px-3 ml-3"
                        @click="nextCrop"
                        >Next</button
                      >
                    </div>
                    <span class=""
                      >{{ cropIndex }}/{{ toCropImages.length }}</span
                    >
                  </div>

                  <div class="mt-3">
                    <button
                      v-if="shouldShowDone"
                      class="button primary-button h-7.5 leading-relax text-sml rounded-small-button px-3"
                      @click="finishCropping"
                      >Done</button
                    >
                  </div>
                </div>
              </template>
            </BaseModalWindow>
          </div>
          <div v-if="shouldShowOrganization" class="mr-12">
            <button
              class="button secondary-button text-basel"
              @click="setShowWhatTags('organization')"
              >+ Business or School</button
            >
          </div>
          <div v-if="shouldShowCause" class="mr-12">
            <button
              class="button secondary-button text-basel"
              @click="setShowWhatTags('cause')"
              >+ Tag a Cause</button
            >
          </div>
          <div v-if="shouldShowFriends" class="mr-12">
            <button
              class="button secondary-button text-basel"
              @click="setShowWhatTags('friends')"
              >+ Tag Friends</button
            >
          </div>
          <div class="mr-12">
            <button
              class="button secondary-button text-basel"
              @click="setShowWhatTags('other')"
              >+ Other Tags</button
            >
          </div>
          <div v-if="shouldShowNextOne" class="">
            <button
              class="button secondary-button text-basel"
              @click="setShowWhatTags('nextOne')"
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1000 1000"
                width="22"
                height="22"
                fill="#069bd7"
                class="inline-block align-middle"
              >
                <title>Kyndhub_Challenges_Icon</title>
                <path
                  d="M403.05,1000h0C180.41,1000,0,819.43,0,596.79s180.56-403.09,403.21-403a403.12,403.12,0,0,1,204.27,55.64l-19,32.2C414.4,179.19,190.26,237.34,87.87,411.45S43.63,809.7,217.74,912.09,616,956.33,718.38,782.22a365.73,365.73,0,0,0,0-370.77l32.2-19c112.86,191.94,48.75,439-143.19,551.89A403.21,403.21,0,0,1,403.09,1000Z"
                  transform="translate(0 0)"
                />
                <path
                  d="M403.05,886.23c-159.81.35-289.64-128.92-290-288.73S242,307.86,401.79,307.51a289.68,289.68,0,0,1,76.48,10.12l-9.67,36.09c-134.42-36.22-272.76,43.38-309,177.8s43.38,272.77,177.81,309,272.76-43.38,309-177.8a252.05,252.05,0,0,0,0-131.19l36.1-9.66c41.65,154.19-49.58,312.95-203.77,354.61a289.09,289.09,0,0,1-75.68,10Z"
                  transform="translate(0 0)"
                />
                <path
                  d="M403,716.09a119.18,119.18,0,1,1,33.47-233.52L710.27,208.78l-6.39-48.1L864.52,0l15.89,119.59L1000,135.48,839.45,296l-48.1-6.39L517.56,563.44A119.14,119.14,0,0,1,403.13,716.05Zm0-201a81.92,81.92,0,1,0,75.71,50.63L474,554.18l303.94-304,48.1,6.39,94.22-94.23-73-9.71-9.71-73-94.23,94.22,6.48,48.14-304,304-11.51-4.76A82,82,0,0,0,403,515Z"
                  transform="translate(0 0)"
                />
                <path d="M605.39,338.93" transform="translate(0 0)" />
              </svg>
              Who Should Do The Next One?</button
            >
          </div>
        </div>
        <VueTagsInput
          v-show="showWhatTags === 'organization'"
          v-model="organizationTag"
          :tags="organizationTags"
          :autocomplete-items="autocompleteOrganizationItems"
          :add-only-from-autocomplete="true"
          :add-on-blur="false"
          :placeholder="organizationPlaceholder()"
          :autocomplete-min-length="2"
          :max-tags="maxOrganizationTags"
          class="mx-auto mb-8"
          @tags-changed="updateOrganization"
        />
        <VueTagsInput
          v-show="showWhatTags === 'cause'"
          v-model="causeTag"
          :tags="causeTags"
          :autocomplete-items="autocompleteCauseItems"
          :add-only-from-autocomplete="true"
          :add-on-blur="false"
          placeholder="Search Cause"
          :autocomplete-min-length="0"
          :autocomplete-always-open="true"
          class="mx-auto mb-8"
          @tags-changed="updateCause"
        />
        <VueTagsInput
          v-show="showWhatTags === 'friends'"
          v-model="friendsTag"
          :tags="friendsTags"
          :autocomplete-items="autocompleteFriendsItems"
          :add-only-from-autocomplete="true"
          :add-on-blur="false"
          placeholder="Search Friends"
          :autocomplete-min-length="2"
          class="mx-auto mb-8"
          @tags-changed="updateFriends"
        />
        <VueTagsInput
          v-show="showWhatTags === 'other'"
          v-model="otherTag"
          :tags="otherTags"
          :autocomplete-items="autocompleteOtherItems"
          :add-only-from-autocomplete="false"
          :add-on-key="[13, ',']"
          placeholder="Search Other Tags"
          class="mx-auto mb-8"
          @tags-changed="updateOther"
        />
        <VueTagsInput
          v-show="showWhatTags === 'nextOne'"
          v-model="nextOneTag"
          :tags="nextOneTags"
          :autocomplete-items="autocompleteNextOneItems"
          :add-only-from-autocomplete="true"
          :add-on-blur="false"
          :placeholder="nextOnePlaceholder()"
          :autocomplete-min-length="2"
          class="mx-auto mb-8"
          :max-tags="maxNextOneTags"
          @tags-changed="updateNextOne"
        />
        <div class="flex mb-6 align-middle leading-xxxl">
          <div class="flex w-post-form overflow-hidden">
            <img
              v-for="(croppedImage, index) in croppedImages"
              :key="`image-${index}`"
              class="w-18 mr-4"
              :src="croppedImage"
            />
          </div>
          <span
            v-if="croppedImages.length > 7"
            class="text-basel text-blue ml-1"
            >+{{ croppedImages.length - 7 }}</span
          >
        </div>
      </div>
    </template>
  </BaseModalWindow>
</template>

<style lang="scss" module>
input[type='file'] {
  display: none;
}
</style>
